import React, { ReactNode } from "react";
import { Site } from "@/services/types";
import { ArrowRight } from "lucide-react";

export const useSiteDescriptions = () => {
  const getSiteDescription = (site: Site): ReactNode => {
    // Descriptions spécifiques par site
    const siteDescriptions: Record<string, ReactNode> = {
      "Lescout Recyclage": (
        <div className="space-y-4">
          <p>
            Situé à proximité de Castres dans le département du Tarn (81), <strong>Lescout Recyclage</strong> est un centre de traitement et de valorisation des déchets industriels appartenant au Groupe Fabre Environnement.
          </p>
          
          <p>
            Notre site de Lescout est spécialisé dans la collecte, le tri et la valorisation des déchets industriels, avec une expertise particulière dans le recyclage des métaux ferreux et non-ferreux.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services à Lescout</h3>
          <ul className="list-none space-y-2">
            <li className="flex items-start">
              <ArrowRight className="h-5 w-5 text-fabre-green mr-3 mt-1 flex-shrink-0" />
              <span><strong>Recyclage de métaux</strong> : Achat et valorisation de tous types de métaux ferreux et non-ferreux</span>
            </li>
            <li className="flex items-start">
              <ArrowRight className="h-5 w-5 text-fabre-green mr-3 mt-1 flex-shrink-0" />
              <span><strong>Démolition industrielle</strong> : Interventions sur site pour la déconstruction et le démantèlement</span>
            </li>
            <li className="flex items-start">
              <ArrowRight className="h-5 w-5 text-fabre-green mr-3 mt-1 flex-shrink-0" />
              <span><strong>Location de bennes</strong> : Pour particuliers et professionnels, avec service de collecte</span>
            </li>
            <li className="flex items-start">
              <ArrowRight className="h-5 w-5 text-fabre-green mr-3 mt-1 flex-shrink-0" />
              <span><strong>Valorisation</strong> : Solutions complètes pour la valorisation de vos déchets industriels</span>
            </li>
          </ul>
          
          <p className="mt-4">
            À seulement quelques kilomètres de Castres, notre équipe professionnelle vous accueille du lundi au vendredi et le samedi matin pour répondre à vos besoins en matière de gestion des déchets industriels.
          </p>
        </div>
      ),
      "SAS Bellé recyclage": (
        <>
          <p className="mb-4">
            SAS Bellé recyclage est un centre de traitement et de valorisation des déchets situé à Rodez. 
            Spécialisé dans la collecte et le recyclage, nous proposons des solutions adaptées aux besoins 
            des professionnels et des collectivités.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Collecte et traitement des déchets industriels</li>
            <li>Recyclage de métaux ferreux et non ferreux</li>
            <li>Gestion des déchets dangereux</li>
            <li>Solutions de valorisation</li>
            <li>Conseils en gestion environnementale</li>
          </ul>
        </>
      ),
      "Centre de Bellé recyclage": (
        <>
          <p className="mb-4">
            SAS Bellé recyclage est un centre de traitement et de valorisation des déchets situé à Rodez. 
            Spécialisé dans la collecte et le recyclage, nous proposons des solutions adaptées aux besoins 
            des professionnels et des collectivités.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Collecte et traitement des déchets industriels</li>
            <li>Recyclage de métaux ferreux et non ferreux</li>
            <li>Gestion des déchets dangereux</li>
            <li>Solutions de valorisation</li>
            <li>Conseils en gestion environnementale</li>
          </ul>
        </>
      ),
      "Briane Jean Récupération": (
        <>
          <p className="mb-4">
            Briane Jean Récupération est une entreprise spécialisée dans la récupération et le recyclage des métaux. 
            Située à Lédergues, notre centre offre des services complets de gestion des déchets métalliques pour 
            les professionnels et les particuliers.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Achat de métaux ferreux et non ferreux</li>
            <li>Collecte de ferraille</li>
            <li>Récupération de déchets</li>
            <li>Dépollution VHU</li>
            <li>Location de bennes</li>
          </ul>
        </>
      ),
      "Centre de Briane Jean Récupération": (
        <>
          <p className="mb-4">
            Le Centre de Briane Jean Récupération, situé à Lédergues, est spécialisé dans la récupération 
            et le recyclage des métaux. Notre équipe d'experts vous accompagne dans toutes vos démarches 
            de recyclage et valorisation des déchets métalliques.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Achat de métaux ferreux et non ferreux</li>
            <li>Collecte de ferraille professionnelle</li>
            <li>Recyclage et valorisation des matériaux</li>
            <li>Récupération et traitement de déchets</li>
            <li>Dépollution de véhicules hors d'usage (VHU)</li>
            <li>Location de bennes pour chantiers et entreprises</li>
          </ul>
          
          <p className="mb-4">
            Nous intervenons auprès des professionnels et des particuliers avec un engagement fort 
            pour l'environnement et le développement durable. Notre expertise nous permet d'offrir 
            des solutions adaptées à chaque besoin.
          </p>
        </>
      ),
      "Profit recyclage": (
        <>
          <p className="mb-4">
            Profit recyclage est une entreprise spécialisée dans la location de bennes et la gestion des déchets.
            Avec des années d'expérience dans le secteur, nous proposons des solutions adaptées à vos besoins en matière de collecte et de traitement des déchets.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Location de bennes de différentes tailles</li>
            <li>Collecte de déchets industriels et ménagers</li>
            <li>Recyclage et valorisation des matériaux</li>
            <li>Tri sélectif pour particuliers et professionnels</li>
            <li>Conseils personnalisés pour la gestion de vos déchets</li>
          </ul>
        </>
      ),
      "Casse Auto du Bassin": (
        <>
          <p className="mb-4">
            La Casse Auto du Bassin est votre spécialiste des pièces détachées automobiles d'occasion. 
            Avec un vaste stock de pièces garanties pour toutes marques et modèles de véhicules, nous vous 
            proposons des solutions économiques et écologiques pour l'entretien et la réparation de votre voiture.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Vente de pièces détachées d'occasion garanties</li>
            <li>Récupération et recyclage de véhicules hors d'usage</li>
            <li>Dépollution automobile conforme aux normes environnementales</li>
            <li>Achat de véhicules accidentés ou en fin de vie</li>
            <li>Service de recherche de pièces spécifiques</li>
          </ul>
          
          <p className="mb-4">
            En choisissant nos pièces d'occasion, vous contribuez à la réduction des déchets automobiles 
            et à la préservation des ressources naturelles, tout en bénéficiant de tarifs avantageux.
          </p>
        </>
      ),
      "RM Recyclage": (
        <>
          <p className="mb-4">
            RM Recyclage est un centre spécialisé dans le recyclage et la valorisation des matériaux. 
            Nous proposons des services complets de collecte et traitement pour les professionnels et particuliers.
          </p>
          
          <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
          <ul className="list-disc pl-5 mb-4">
            <li>Collecte et valorisation de déchets</li>
            <li>Recyclage de matériaux divers</li>
            <li>Achat de métaux et matières valorisables</li>
            <li>Solutions environnementales adaptées</li>
            <li>Conseil en gestion des déchets</li>
          </ul>
        </>
      )
    };

    // Si une description spécifique existe, la retourner
    if (site && site.name && siteDescriptions[site.name]) {
      return siteDescriptions[site.name];
    }

    // Description générique si aucune spécifique n'est trouvée
    return (
      <div className="space-y-4">
        <p>
          Le site {site?.name} fait partie du Groupe Fabre Environnement, spécialisé dans la collecte, le tri et la valorisation des déchets.
        </p>
        <p>
          Notre équipe de professionnels est à votre disposition pour vous aider à gérer vos déchets de manière responsable et écologique.
        </p>
        <h3 className="text-xl font-semibold mb-2 text-fabre-darkgreen">Nos services</h3>
        <ul className="list-none space-y-2">
          {site?.services?.map((service, index) => (
            <li key={index} className="flex items-start">
              <ArrowRight className="h-5 w-5 text-fabre-green mr-3 mt-1 flex-shrink-0" />
              <span>{service}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  return { getSiteDescription };
};
